import { Gender } from "../types/personal_info.types";

export const GENDER_OPTIONS = [
  { key: Gender.MALE, value: "Masculino" },
  { key: Gender.FEMALE, value: "Femenino" },
];
